import { render, staticRenderFns } from "./SliderOnboardingProgrammed.vue?vue&type=template&id=e4a38b6a&"
import script from "./SliderOnboardingProgrammed.vue?vue&type=script&lang=js&"
export * from "./SliderOnboardingProgrammed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports